import { create } from "zustand";

interface AuthUser {
  id: number;
  email: string;
  name: string;
  role: string;
}

interface AuthTenant {
  id: number;
  name: string;
  slug: string;
  plan: string;
}

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  tenant: AuthTenant | null;
  isAuthenticated: boolean;
  setAuth: (data: { token: string; refreshToken: string; user: AuthUser; tenant: AuthTenant }) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem("radar_token"),
  refreshToken: localStorage.getItem("radar_refresh"),
  user: JSON.parse(localStorage.getItem("radar_user") || "null"),
  tenant: JSON.parse(localStorage.getItem("radar_tenant") || "null"),
  isAuthenticated: !!localStorage.getItem("radar_token"),

  setAuth: (data) => {
    localStorage.setItem("radar_token", data.token);
    localStorage.setItem("radar_refresh", data.refreshToken);
    localStorage.setItem("radar_user", JSON.stringify(data.user));
    localStorage.setItem("radar_tenant", JSON.stringify(data.tenant));
    set({
      token: data.token,
      refreshToken: data.refreshToken,
      user: data.user,
      tenant: data.tenant,
      isAuthenticated: true,
    });
  },

  logout: () => {
    localStorage.removeItem("radar_token");
    localStorage.removeItem("radar_refresh");
    localStorage.removeItem("radar_user");
    localStorage.removeItem("radar_tenant");
    set({
      token: null,
      refreshToken: null,
      user: null,
      tenant: null,
      isAuthenticated: false,
    });
  },
}));
